module.exports = __webpack_public_path__ + "img/goldLogo.c126efa7.svg";